import WebFont from 'webfontloader'
import { loadedWebFonts } from '@meta/fonts'

const state = {
  loadedFonts: [],
  toLoadWebFontsList: loadedWebFonts,
  isLoading: false,
  loadPromise: null,
}

const mutations = {
  ADD_LOADED_FONT(state, font) {
    if (!state.loadedFonts.includes(font)) {
      state.loadedFonts.push(font)
    }
  },
  SET_LOADING(state, status) {
    state.isLoading = status
  },
  SET_LOAD_PROMISE(state, promise) {
    state.loadPromise = promise
  },
}

const actions = {
  loadFonts({ commit, state }, fontsToLoad) {
    // Allow loading additional fonts by passing an argument
    let fonts = state.toLoadWebFontsList

    if (fontsToLoad && Array.isArray(fontsToLoad)) {
      fonts = [...new Set([...state.toLoadWebFontsList, ...fontsToLoad])]
    }

    const newFonts = fonts.filter(
      (font) => !state.loadedFonts.includes(font)
    )
    if (newFonts.length === 0) {
      return Promise.resolve()
    }

    if (state.isLoading) {
      return state.loadPromise
    }

    commit('SET_LOADING', true)

    const loadPromise = new Promise((resolve, reject) => {
      WebFont.load({
        google: {
          families: newFonts,
        },
        active: () => {
          newFonts.forEach((font) => commit('ADD_LOADED_FONT', font))
          commit('SET_LOADING', false)
          resolve()
        },
        inactive: () => {
          commit('SET_LOADING', false)
          reject(new Error('Web fonts failed to load.'))
        },
      })
    })

    commit('SET_LOAD_PROMISE', loadPromise)
    return loadPromise
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}